import { define } from 'wicked-elements'
import 'vlitejs/dist/vlite.css'
import Vlitejs from 'vlitejs'

define('[data-component~="player"]', {
  init () {
    this.$media = this.element.querySelector('.vlite-js')
  },
  connected () {
    this.player = new Vlitejs(this.$media, {
      options: {
        autoHide: true  
      }
    })
  },
  disconnected () {
    this.player.destroy()
  }
})